import { theme } from './constants/theme';

export default theme;
